/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
function o(o,t,n){return o.goTo(t,n)}function t(){return(o,t)=>o.goTo(t.target,{...t.options,animate:!1})}export{o as goTo,t as makeGoToWithoutAnimation};
